module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/id_6-102e397d9eeca3c27a548052bfc7bf2f.jpg";